// import getConfig from 'next/config';
// const { publicRuntimeConfig } = getConfig();

// console.log('ini public runtime : ', publicRuntimeConfig);

export const API = 'https://apiubaforms.herokuapp.com/api/v1';
// export const API = 'http://localhost:9002/api/v1';

// export const APP_NAME = publicRuntimeConfig.APP_NAME;
// export const DOMAIN = publicRuntimeConfig.PRODUCTION
//   ? publicRuntimeConfig.DOMAIN_PRODUCTION
//   : publicRuntimeConfig.DOMAIN_DEVELOPMENT;

// export const FB_APP_ID = publicRuntimeConfig.FB_APP_ID;
// export const DISQUS_SHORTNAME = publicRuntimeConfig.DISQUS_SHORTNAME;
// export const GOOGLE_CLIENT_ID = publicRuntimeConfig.GOOGLE_CLIENT_ID;
